module.exports = __webpack_public_path__ + "img/completed.41cdaf8e.svg";